var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll flex flex-col space-y-3 py-2"
};
const _hoisted_3 = { class: "flex flex-col space-y-2" };
const _hoisted_4 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_5 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_6 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_7 = { class: "w-40 flex items-center" };
const _hoisted_8 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_9 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_10 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_11 = { class: "w-40 flex items-center" };
const _hoisted_12 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_13 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_14 = { class: "flex flex-row space-x-6 px-3 border border-gray-300 rounded-lg items-center" };
const _hoisted_15 = { class: "text-md font-normal text-gray-400 px-4" };
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import { Identifiers } from '@/types/identifiers';
import { Tools } from '@/types/tools';
import { UIColorPicker, UIInputNumber, UISlider } from '@gohighlevel/ghl-ui';
import Konva from 'konva';
import { computed, inject, onMounted, onUnmounted, ref, watch, } from 'vue';
import EmitterEvent from '@/events';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BrushTool',
    props: {
        stage: {
            type: Object,
            require: true,
        },
        group: {
            type: Object,
            require: true,
        },
        selectedOption: {
            type: String,
            require: true,
        },
        loading: {
            type: Boolean,
            require: true,
        },
    },
    setup(__props) {
        const props = __props;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        let lastLine, cursor, lineTransformer;
        const brushHardness = ref(100);
        const brushColor = ref('#000000');
        const brushSize = ref(24);
        const isDrawing = ref(false);
        const beforeObject = ref();
        const afterObject = ref(0);
        const lineElements = ref([]);
        const activeNodeIndex = ref(0);
        const activeTool = computed(() => props.selectedOption);
        const isLoading = computed(() => props.loading);
        watch(activeTool, (newVal, oldVal) => __awaiter(this, void 0, void 0, function* () {
            if (activeTool.value === Tools.BRUSH) {
                // set event listener
                createLineTransformer();
                setClickEventListeners();
                setEventListener();
                cursor = props.stage.find(`#${Identifiers.CURSOR_IMAGE_ID}`)[0];
            }
            else if (oldVal === Tools.BRUSH) {
                // remove event listener
                removeEventListener();
            }
        }));
        watch(isLoading, () => __awaiter(this, void 0, void 0, function* () {
            if (!isLoading.value) {
                brushSize.value = Math.round(props.stage.width() * 0.04);
            }
        }));
        onMounted(() => {
            emitter.on(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, setActiveElement);
        });
        onUnmounted(() => {
            removeEventListener();
        });
        function removeEventListener() {
            props.group.off('mousedown touchstart mouseup touchend mousemove touchmove');
            props.stage.off('mouseover mouseout mousemove touchmove');
            if (lineElements.value.length) {
                lineElements.value.forEach(line => line.off('click mouseover mouseout'));
            }
            if (lineTransformer)
                lineTransformer.detach();
        }
        function setActiveElement(history) {
            if (history && history.source === Tools.BRUSH) {
                lastLine = props.group.find(`#${history.id}`)[0];
                setClickEvent(lastLine);
            }
        }
        function setEventListener() {
            props.stage.on('mouseover', () => {
                document.body.style.cursor = 'none';
                const pos = props.stage.getPointerPosition();
                cursor.position({
                    x: pos.x - cursor.width() / 2,
                    y: pos.y - cursor.height() / 2,
                });
                cursor.show();
            });
            props.stage.on('mouseleave', function () {
                cursor.hide();
                document.body.style.cursor = 'default';
                if (isDrawing.value) {
                    isDrawing.value = false;
                    setBeforeObject(HistoryType.REMOVE);
                    setAfterObject(HistoryType.ADD, lastLine);
                    setHistory(HistoryType.ADD);
                }
            });
            props.group.on('mousedown touchstart', () => {
                isDrawing.value = true;
                createLineElement();
            });
            props.group.on('mouseup touchend', () => {
                isDrawing.value = false;
                setBeforeObject(HistoryType.REMOVE);
                setAfterObject(HistoryType.ADD, lastLine);
                setHistory(HistoryType.ADD);
            });
            props.stage.on('mousemove touchmove', () => {
                const pos = props.stage.getPointerPosition();
                cursor.position({
                    x: pos.x - cursor.width() / 2,
                    y: pos.y - cursor.height() / 2,
                });
            });
            props.group.on('mousemove touchmove', () => {
                if (!isDrawing.value) {
                    return;
                }
                const brushHard = brushHardness.value / 100;
                const pos = props.stage.getPointerPosition();
                const newPoints = lastLine.points().concat([pos.x, pos.y]);
                lastLine.points(newPoints);
                lastLine.opacity(brushHard);
                props.stage.batchDraw();
            });
        }
        function createLineElement() {
            const pos = props.stage.getPointerPosition();
            activeNodeIndex.value = lineElements.value.length;
            lastLine = new Konva.Line({
                stroke: brushColor.value,
                strokeWidth: brushSize.value,
                lineCap: 'round',
                lineJoin: 'round',
                globalCompositeOperation: 'source-over',
                points: [pos.x, pos.y],
                id: `${Identifiers.BRUSH_ID_PREFIX}${activeNodeIndex.value}`,
                opacity: 1,
            });
            props.group.add(lastLine);
            lineElements.value.push(lastLine);
            cursor.moveToTop();
            setClickEvent(lastLine);
        }
        function createLineTransformer() {
            if (lineTransformer)
                return;
            lineTransformer = new Konva.Transformer({
                enabledAnchors: [],
                // set minimum width of text
                boundBoxFunc: function (oldBox, newBox) {
                    newBox.width = Math.max(30, newBox.width);
                    newBox.height = Math.max(30, newBox.height);
                    return newBox;
                },
                centeredScaling: true,
                padding: 10,
                id: Identifiers.BRUSH_TRANSFORMER,
                keepRatio: true,
            });
        }
        function setBeforeObject(type, node) {
            beforeObject.value = getHistoryObject(Tools.BRUSH, node, type);
        }
        function setAfterObject(type, node) {
            afterObject.value = getHistoryObject(Tools.BRUSH, node, type);
        }
        function setHistory(type) {
            const id = lastLine.id();
            historyStore.setHistory(id, Tools.BRUSH, beforeObject.value, afterObject.value, type);
        }
        function setClickEvent(node) {
            node.on('click', e => {
                lineTransformer.detach();
                lineTransformer.nodes([e.target]);
            });
            node.on('mouseover', () => {
                cursor.hide();
                document.body.style.cursor = 'move';
            });
            node.on('mouseout', () => {
                cursor.show();
                document.body.style.cursor = 'none';
            });
        }
        function setClickEventListeners() {
            if (lineElements.value.length) {
                lineElements.value.forEach(line => {
                    setClickEvent(line);
                });
            }
        }
        function handleBrushSizeChange() {
            // do brush size update
            cursor.setAttrs({
                width: brushSize.value,
                height: brushSize.value,
            });
        }
        function handleBrushHardness() {
            // do hardness related changes
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('brush.title')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('brush.brushHardness')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-brush-hardness-input",
                                    size: "medium",
                                    value: brushHardness.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((brushHardness).value = $event)),
                                    style: { "width": "58px" },
                                    showButton: false,
                                    placeholder: "",
                                    onBlur: handleBrushHardness
                                }, null, 8 /* PROPS */, ["value"]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(UISlider), {
                                        value: brushHardness.value,
                                        "onUpdate:value": [
                                            _cache[1] || (_cache[1] = ($event) => ((brushHardness).value = $event)),
                                            handleBrushHardness
                                        ],
                                        step: 1,
                                        tooltip: false,
                                        min: 0,
                                        max: 100
                                    }, null, 8 /* PROPS */, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('brush.brushSize')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-brush-size-input",
                                    size: "medium",
                                    value: brushSize.value,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((brushSize).value = $event)),
                                    style: { "width": "58px" },
                                    showButton: false,
                                    placeholder: "",
                                    onBlur: handleBrushSizeChange
                                }, null, 8 /* PROPS */, ["value"]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_unref(UISlider), {
                                        value: brushSize.value,
                                        "onUpdate:value": [
                                            _cache[3] || (_cache[3] = ($event) => ((brushSize).value = $event)),
                                            handleBrushSizeChange
                                        ],
                                        step: 1,
                                        tooltip: false,
                                        min: 0,
                                        max: 100
                                    }, null, 8 /* PROPS */, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('brush.brushColor')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_unref(UIColorPicker), {
                                    compact: true,
                                    modes: () => ['rgb', 'hex', 'hsl'],
                                    defaultShow: false,
                                    defaultValue: brushColor.value,
                                    value: brushColor.value,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((brushColor).value = $event))
                                }, null, 8 /* PROPS */, ["modes", "defaultValue", "value"]),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(brushColor.value), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
